import { render } from "./BaseTableProjectManagementQuestions.vue?vue&type=template&id=3c23caeb&scoped=true"
import script from "./BaseTableProjectManagementQuestions.vue?vue&type=script&lang=js"
export * from "./BaseTableProjectManagementQuestions.vue?vue&type=script&lang=js"

import "./BaseTableProjectManagementQuestions.vue?vue&type=style&index=0&id=3c23caeb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c23caeb"]])

export default __exports__